import HighResImageGallery from './high-res-image-gallery';

export default HighResImageGallery;
